/**
 * @desc 通过sku列表和状态获取sku信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SkuListResponseDto>>;
export function request(
  body: defs.basics.SkuListAndStatusRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/sku/bySkuListAndStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
